/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { ActionInput } from './ActionInput';

export type ActionDTO = {
    id: number;
    testCaseId: number;
    type: ActionDTO.type;
    matcherId?: number;
    inputs: Array<ActionInput>;
    disabled: boolean;
    timeout?: number;
    index: number;
    imageUrl?: string;
    branches: string;
};

export namespace ActionDTO {

    export enum type {
        POINTER = 'POINTER',
        TEXT = 'TEXT',
        MARKER = 'MARKER',
        CONTROL = 'CONTROL',
        PROMPT = 'PROMPT',
    }


}

